import React from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';

import styles from '../styles.styl';

function ImgRadLabVisitView({ formatMessage, reasonType, location }) {
  return (
    <div styleName="row">
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          <div className={styles.meta}>
            {formatMessage({
              id: 'appointment.list.card.location',
            })}
          </div>
        </div>
        <div className={styles.column}>
          <span className={styles.provider}>{location}</span>
        </div>
      </div>
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          <div className={styles.meta}>
            {formatMessage({
              id: 'appointment.list.card.reasonForVisit',
            })}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.provider}>{reasonType}</div>
        </div>
      </div>
    </div>
  );
}

ImgRadLabVisitView.propTypes = {
  formatMessage: PropTypes.func,
  reasonType: PropTypes.string,
  location: PropTypes.string,
};

export default CSSModules(ImgRadLabVisitView, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/Views/ImgRadLabVisitView.jsx